import React from 'react';

import PropTypes from 'prop-types';

export default function GridCog({
  color = 'currentColor',
  size = '512',
  ...rest
}) {
  return (
    <svg
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      height={size}
      width={size}
      {...rest}
    >
      <g
        transform="translate(0,512) scale(0.1,-0.1)"
        fill={color}
        stroke="none"
      >
        <path
          d="M500 5104 c-177 -38 -348 -171 -429 -334 -75 -154 -71 -33 -71 -1890
          0 -1857 -4 -1736 71 -1890 81 -164 255 -298 434 -335 97 -20 1621 -22 1649 -2
          22 16 22 37 2 117 -9 37 -16 107 -16 163 0 143 11 137 -249 137 -206 0 -210 0
          -225 22 -14 19 -16 77 -16 428 0 351 2 409 16 428 15 21 20 22 218 22 158 0
          206 3 221 14 15 11 22 36 31 103 7 48 15 106 19 129 13 72 7 74 -246 74 -206
          0 -220 1 -239 20 -20 20 -20 33 -20 570 0 537 0 550 20 570 19 19 33 20 458
          20 380 0 440 -2 460 -16 22 -15 22 -15 22 -353 0 -413 -7 -389 120 -372 46 6
          104 11 130 11 25 0 51 5 58 12 9 9 12 99 12 345 0 320 1 334 20 353 19 19 33
          20 433 20 484 0 457 6 457 -95 0 -74 12 -88 89 -99 55 -8 161 -50 222 -88 56
          -34 84 -35 104 -4 14 21 16 99 13 713 -4 759 -2 732 -69 866 -90 177 -243 297
          -436 341 -65 14 -228 16 -1635 15 -1298 0 -1574 -3 -1628 -15z m818 -426 c17
          -17 17 -859 0 -876 -19 -19 -861 -17 -877 2 -9 10 -11 115 -9 384 l3 370 30
          43 c17 23 50 53 74 66 44 23 47 23 406 23 267 0 364 -3 373 -12z m1280 0 c17
          -17 17 -859 0 -876 -9 -9 -126 -12 -464 -12 l-453 0 -15 22 c-14 19 -16 77
          -16 428 0 351 2 409 16 428 l15 22 453 0 c338 0 455 -3 464 -12z m1120 -7 c48
          -25 87 -66 106 -113 24 -56 24 -729 0 -752 -14 -14 -67 -16 -439 -16 l-424 0
          -15 22 c-14 19 -16 77 -16 428 0 351 2 409 16 428 l15 22 360 0 c334 0 362 -1
          397 -19z m-2410 -1217 l22 -15 0 -559 0 -559 -22 -15 c-19 -14 -77 -16 -428
          -16 -351 0 -409 2 -428 16 l-22 15 0 559 0 559 22 15 c19 14 77 16 428 16 351
          0 409 -2 428 -16z m10 -1496 c19 -19 17 -861 -2 -877 -10 -9 -114 -11 -383 -9
          l-369 3 -37 25 c-21 14 -50 43 -65 64 l-27 39 -3 370 c-2 269 0 373 9 383 16
          19 858 21 877 2z"
        />
        <path
          d="M3663 2952 c-92 -33 -174 -104 -215 -187 -9 -16 -36 -100 -62 -185
          -60 -201 -64 -208 -97 -225 -39 -21 -45 -20 -238 25 -192 45 -243 48 -329 22
          -221 -69 -327 -312 -229 -526 16 -35 67 -98 149 -187 136 -146 148 -163 148
          -208 0 -31 -10 -44 -191 -244 -94 -105 -122 -153 -138 -243 -23 -124 21 -246
          119 -337 118 -110 223 -124 475 -63 256 61 252 63 325 -178 59 -197 82 -245
          141 -305 178 -178 488 -130 602 94 8 17 40 111 70 209 30 98 61 185 69 192 32
          33 69 32 217 -2 217 -51 249 -55 314 -44 132 21 233 98 290 218 28 60 32 77
          32 157 0 131 -27 182 -186 354 -135 145 -148 163 -149 203 0 28 24 59 192 242
          119 130 142 179 142 306 0 118 -27 182 -108 265 -46 46 -76 68 -121 85 -103
          38 -157 37 -359 -9 -98 -23 -189 -41 -202 -41 -13 0 -37 12 -53 28 -25 22 -38
          55 -77 187 -25 88 -60 186 -77 218 -37 70 -100 130 -175 165 -75 35 -201 41
          -279 14z m277 -844 c25 -6 83 -28 130 -51 67 -31 101 -56 161 -116 83 -84 120
          -140 156 -238 88 -244 16 -525 -179 -698 -63 -55 -188 -119 -278 -141 -95 -24
          -262 -15 -352 18 -187 70 -326 209 -396 396 -30 82 -41 239 -22 334 50 260
          268 467 534 509 59 9 180 3 246 -13z"
        />
        <path
          d="M3709 1796 c-184 -49 -284 -240 -222 -422 24 -71 120 -164 192 -187
          215 -68 424 78 424 298 0 151 -93 272 -240 310 -67 18 -92 18 -154 1z"
        />
      </g>
    </svg>
  );
}

GridCog.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
